<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-shop"></i> 门店列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 - 优化布局 -->
      <div class="search-bar">
        <el-form :model="searchForm" size="small" label-width="70px" label-position="right">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="门店名称">
                <el-input 
                  v-model="searchForm.name" 
                  placeholder="请输入门店名称"
                  prefix-icon="el-icon-search"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="门店编码">
                <el-input 
                  v-model="searchForm.sn" 
                  placeholder="请输入门店编码"
                  prefix-icon="el-icon-document"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="门店类别">
                <el-select
                  v-model="searchForm.grade_id"
                  placeholder="请选择门店类别"
                  clearable
                >
                  <el-option
                    v-for="item in gradeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="审核状态">
                <el-select
                  v-model="searchForm.is_auth"
                  placeholder="请选择审核状态"
                  clearable
                >
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="已审核" :value="1"></el-option>
                  <el-option label="驳回" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="所属区域">
                <el-cascader
                  v-model="regionList"
                  :props="regionProps"
                  :options="regionOptions"
                  placeholder="请选择省/市/区"
                  clearable
                  filterable
                  style="width: 100%;"
                  @change="handleRegionChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="search-actions">
              <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
              <el-button @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
              <el-button type="success" @click="addData" icon="el-icon-plus">新增门店</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card" @click="filterStatus('all')">
          <div class="stat-icon total"><i class="el-icon-shop"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">全部门店</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('pending')">
          <div class="stat-icon pending"><i class="el-icon-time"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ pendingCount }}</div>
            <div class="stat-label">待审核</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('approved')">
          <div class="stat-icon approved"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ approvedCount }}</div>
            <div class="stat-label">已审核</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('rejected')">
          <div class="stat-icon rejected"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ rejectedCount }}</div>
            <div class="stat-label">已驳回</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          row-key="id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="门店信息" min-width="200">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name"><i class="el-icon-shop"></i><span>{{ scope.row.name }}</span></div>
                <div class="shop-sn"><span class="label">编码：</span><span class="value">{{ scope.row.sn }}</span></div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="门店分类" width="120" align="center">
            <template slot-scope="scope">
              <el-tag size="small" type="primary" effect="plain">
                {{ scope.row.category ? scope.row.category.name : '-' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="联系人" width="130" align="center">
            <template slot-scope="scope">
              <div class="contact-info">
                <div class="contact-name"><i class="el-icon-user"></i><span>{{ scope.row.cont_name || '-' }}</span></div>
                <div class="contact-phone"><i class="el-icon-phone"></i><span>{{ scope.row.telephone || '-' }}</span></div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="区域地址" min-width="280">
            <template slot-scope="scope">
              <div class="address-info">
                <div class="region"><i class="el-icon-location"></i>
                  <span>{{ scope.row.province_name || '' }}</span>
                  <span v-if="scope.row.city_name"> / {{ scope.row.city_name }}</span>
                  <span v-if="scope.row.district_name"> / {{ scope.row.district_name }}</span>
                  <span v-if="!scope.row.province_name && !scope.row.city_name && !scope.row.district_name">-</span>
                </div>
                <div class="address">{{ scope.row.address || '-' }}</div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.is_auth)" size="small" effect="plain">
                {{ getStatusText(scope.row.is_auth) }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.row)">
                <el-button type="primary" size="small" plain>
                  更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="view"><i class="el-icon-view"></i> 查看</el-dropdown-item>
                  <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 修改</el-dropdown-item>
                  <el-dropdown-item command="auth" v-if="scope.row.is_auth == 0"><i class="el-icon-check"></i> 审核</el-dropdown-item>
                  <el-dropdown-item command="file"><i class="el-icon-picture"></i> 添加资料</el-dropdown-item>
                  <el-dropdown-item command="follow"><i class="el-icon-star-on"></i> 跟进</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-shop"></i><p>暂无门店数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>
    </el-card>

    <!-- 审核弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :close-on-click-modal="false" class="alipay-dialog" @closed="handleDialogClosed">
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right">
          <el-form-item label="门店名称" prop="name"><el-input v-model="form.name" readonly disabled></el-input></el-form-item>
          <el-form-item label="审核状态" prop="is_auth">
            <el-select v-model="form.is_auth" placeholder="请选择审核状态" class="full-width">
              <el-option label="待审核" :value="0"><span style="color: #e6a23c;">● 待审核</span></el-option>
              <el-option label="已审核" :value="1"><span style="color: #00b578;">● 已审核</span></el-option>
              <el-option label="驳回" :value="2"><span style="color: #ff4d4f;">● 驳回</span></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片资料弹框 -->
    <eFileList :formData="formData1" :visible="visible1" :title="title1" :closeForm="closeForm1" />
  </div>
</template>

<script>
import eFileList from "./components/eFileList.vue";

export default {
  name: "shopList",
  components: { eFileList },
  data() {
    return {
      loading: false,
      totalCount: 0, pendingCount: 0, approvedCount: 0, rejectedCount: 0,
      gradeList: [],
      
      // 搜索表单
      searchForm: { name: "", sn: "", grade_id: "", is_auth: "" },
      
      // 区域选择
      regionList: [],
      regionOptions: [],
      regionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        lazy: true,
        lazyLoad: this.loadRegionData,
        checkStrictly: true
      },
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1, pageSize: 10, total: 0,
      
      // 弹框控制
      dialogFormVisible: false, dialogTitle: '', title1: '', visible1: false,
      form: { name: '', id: '', is_auth: '' },
      formData1: {},
      rules: { is_auth: [{ required: true, message: '请选择审核状态', trigger: 'change' }] }
    }
  },
  created() {
    this.DataList()
    this.getGradeList()
    this.loadRegionTree()
  },
  methods: {
    headerCellStyle() { return { background: '#f5f7fa', color: '#1f2d3d', fontWeight: '500', fontSize: '14px', borderBottom: '1px solid #e4e7ed' } },
    rowStyle() { return { cursor: 'pointer' } },
    getStatusType(status) { return status == 1 ? 'success' : (status == 2 ? 'danger' : 'warning') },
    getStatusText(status) { return status == 1 ? '已审核' : (status == 2 ? '驳回' : '待审核') },
    
    // 加载区域树
    loadRegionTree() {
      const param = { access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id'), parent_id: 1 }
      this.$axios.regionList(param).then(res => {
        if (res.code == 200) this.regionOptions = res.data || []
      }).catch(error => console.log(error))
    },
    
    // 懒加载区域数据
    loadRegionData(node, resolve) {
      if (node.level === 0) {
        const param = { access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id'), parent_id: 1 }
        this.$axios.regionList(param).then(res => {
          if (res.code == 200) resolve(res.data.map(item => ({ ...item, leaf: false })))
          else resolve([])
        }).catch(() => resolve([]))
      } else {
        const param = { access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id'), parent_id: node.value }
        this.$axios.regionList(param).then(res => {
          if (res.code == 200) resolve(res.data.map(item => ({ ...item, leaf: true })))
          else resolve([])
        }).catch(() => resolve([]))
      }
    },
    
    // 区域选择变化
    handleRegionChange(value) {
      if (value && value.length > 0) {
        const provinceId = value[0]
        const cityId = value.length > 1 ? value[1] : null
        const districtId = value.length > 2 ? value[2] : null
        this.searchForm.province_id = provinceId
        this.searchForm.city_id = cityId
        this.searchForm.district_id = districtId
      } else {
        delete this.searchForm.province_id
        delete this.searchForm.city_id
        delete this.searchForm.district_id
      }
    },
    
    // 计算统计数据
    calculateStats() {
      const countNodes = (data) => {
        let total = 0, pending = 0, approved = 0, rejected = 0
        for (const item of data) {
          total++
          if (item.is_auth == 0) pending++
          else if (item.is_auth == 1) approved++
          else if (item.is_auth == 2) rejected++
          if (item.children && item.children.length) {
            const childStats = countNodes(item.children)
            total += childStats.total; pending += childStats.pending
            approved += childStats.approved; rejected += childStats.rejected
          }
        }
        return { total, pending, approved, rejected }
      }
      const stats = countNodes(this.tableLoadData)
      this.totalCount = stats.total; this.pendingCount = stats.pending
      this.approvedCount = stats.approved; this.rejectedCount = stats.rejected
    },
    
    filterStatus(type) {
      if (type === 'pending') this.searchForm.is_auth = 0
      else if (type === 'approved') this.searchForm.is_auth = 1
      else if (type === 'rejected') this.searchForm.is_auth = 2
      else this.searchForm.is_auth = ''
      this.searchSubmit()
    },
    
    getGradeList() {
      const param = { company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') }
      this.$axios.shopGradeList(param).then(res => { if (res.code == 200) this.gradeList = res.data || [] }).catch(error => console.log(error))
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    DataList() {
      this.loading = true
      const param = { company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token'), proxy_id: sessionStorage.getItem('proxy_id') }
      if (this.searchForm.name) param.name = this.searchForm.name
      if (this.searchForm.sn) param.sn = this.searchForm.sn
      if (this.searchForm.grade_id) param.grade_id = this.searchForm.grade_id
      if (this.searchForm.is_auth !== '') param.is_auth = this.searchForm.is_auth
      if (this.searchForm.province_id) param.province_id = this.searchForm.province_id
      if (this.searchForm.city_id) param.city_id = this.searchForm.city_id
      if (this.searchForm.district_id) param.district_id = this.searchForm.district_id
      
      this.$axios.findShopTree(param).then(res => {
        this.loading = false
        if (res.code == 200) { this.tableLoadData = res.data || []; this.calculateStats() }
      }).catch(error => { this.loading = false; console.log(error) })
    },
    
    searchSubmit() { this.pageNum = 1; this.DataList() },
    resetSearch() { this.searchForm = { name: "", sn: "", grade_id: "", is_auth: "" }; this.regionList = []; this.searchSubmit() },
    addData() { this.$router.push('/shopForm') },
    goInfo(row) { this.$router.push({ path: '/shopInfo', query: { id: row.id } }) },
    goEdit(row) { this.$router.push({ path: '/shopForm', query: { id: row.id } }) },
    goAuth(row) { this.dialogTitle = '门店审核'; this.form.id = row.id; this.form.name = row.name; this.form.is_auth = row.is_auth; this.dialogFormVisible = true },
    goFile(row) { this.title1 = "图片资料"; this.formData1.shop_id = row.id; this.visible1 = true },
    goFollow() { this.$message.info('跟进功能开发中') },
    closeForm1() { this.title1 = ""; this.visible1 = false; this.DataList() },
    
    handleCommand(command, row) {
      switch(command) {
        case 'view': this.goInfo(row); break
        case 'edit': this.goEdit(row); break
        case 'auth': this.goAuth(row); break
        case 'file': this.goFile(row); break
        case 'follow': this.goFollow(row); break
      }
    },
    
    handleDialogClosed() { this.$refs.form?.resetFields() },
    cancelForm() { this.dialogFormVisible = false },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid && this.form.id) {
          const param = { id: this.form.id, is_auth: this.form.is_auth, company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') }
          this.$axios.shopAuth(param).then(res => { if (res.code == 200) { this.$message.success(res.msg); this.DataList(); this.dialogFormVisible = false } else { this.$message.error(res.msg) } })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item { margin-bottom: 16px; width: 100%; }
  .el-form-item__label { font-size: 12px; padding-right: 8px; font-weight: 500; color: #606266; }
  
  .el-input ::v-deep .el-input__inner,
  .el-select ::v-deep .el-input__inner,
  .el-cascader ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: -4px;
    
    .el-button {
      border-radius: 20px;
      padding: 8px 18px;
    }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; border-color: #1acd8c; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 160px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease; cursor: pointer;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff; }
    .stat-info { .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; } .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; } }
    .total { background: linear-gradient(135deg, #1677ff, #4096ff); }
    .pending { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    .approved { background: linear-gradient(135deg, #00b578, #1acd8c); }
    .rejected { background: linear-gradient(135deg, #ff4d4f, #ff7875); }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.shop-info { .shop-name { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; i { font-size: 16px; color: #1677ff; } span { font-weight: 500; } } .shop-sn { .label { font-size: 12px; color: #8c8f98; } .value { font-size: 12px; color: #1677ff; font-family: monospace; } } }

.contact-info { .contact-name { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #e6a23c; font-size: 12px; } span { font-size: 13px; } } .contact-phone { display: flex; align-items: center; gap: 6px; i { color: #00b578; font-size: 12px; } span { font-size: 12px; color: #8c8f98; } } }

.address-info { .region { display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 4px; i { color: #909399; font-size: 12px; margin-right: 4px; } span { font-size: 12px; color: #606266; } } .address { font-size: 12px; color: #8c8f98; word-break: break-all; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}

.dialog-content .el-form-item { margin-bottom: 22px; }
.full-width { width: 100%; }

.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 24px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}

@media (max-width: 1200px) {
  .search-bar .search-actions { margin-top: 0; justify-content: flex-start; }
}
</style>